var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails, AccordionSummary, Chip, Drawer, Grid, TextField, Typography, styled, useMediaQuery } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import { t } from 'i18next';
import { debounce } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MuiBox, MuiStack } from '../..';
import { ComplaintGroupBasedOnIdURL, ComplaintGroupURL, ComplaintsJobItemsSearchURL, getSavedJobItemsJobCardUrl, getSavedJobItemsUrl, translateToJobDownloadAttchementURl } from '../../../api/url';
import { CrossIcon, SearchIcon } from '../../../assets/images';
import { downloadAttachment, showLoader } from '../../../redux/commonSlice';
import { getByIdAPI, getListAPI } from '../../../redux/crudSlice';
import { useAppSelector } from '../../../store/hooks';
import { sortImagesByTimeStamp } from '../../../utils/utils';
import { MuiIconButton } from '../../atoms/iconButtonComponent';
import JobItemsLoader from '../../atoms/jobItemsLoader';
import Loader from '../../molecules/loader';
import { PageHeading } from '../../molecules/pageHeading';
import ViewJobsDetails from './viewJobs.details';
var Accordion = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordion, _extends({
    disableGutters: true,
    elevation: 0,
    square: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        border: "1px solid ".concat(theme.palette.divider),
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '&:before': {
            display: 'none'
        }
    };
});
var DrawerHeader = styled('div')(function (_ref2) {
    var theme = _ref2.theme;
    return _objectSpread({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: theme.spacing(0, 2)
    }, theme.mixins.toolbar);
});
export default function VehicleDetailsViewJobs(props) {
    var _this = this;
    var customerVoiceId = props.customerVoiceId, isFromJobCard = props.isFromJobCard, requestID = props.requestID;
    var _a = React.useState(null), expanded = _a[0], setExpanded = _a[1];
    var _b = useState([]), listValue = _b[0], setListValue = _b[1];
    var _c = React.useState([]), savedJobItemsAgainsComplaint = _c[0], setSavedJobItemsAgainsCompalint = _c[1];
    var _d = React.useState([]), complaintsGroupsList = _d[0], setComplaintsGroupsList = _d[1];
    var _e = React.useState(""), searchValue = _e[0], setSearchValue = _e[1];
    var _f = React.useState([]), searchResult = _f[0], setSearchResult = _f[1];
    var _g = React.useState(false), showSkeleton = _g[0], setShowSkeleton = _g[1];
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var dispatch = useDispatch();
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _h = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _h.documentDetailsGetById, ModuleDetailsGetById = _h.ModuleDetailsGetById, preDocumentFetch = _h.preDocumentFetch;
    React.useEffect(function () {
        getTranslateToJobItems();
    }, []);
    var sendRequest = useCallback(function (value) {
        handleSearchChange(value);
    }, [complaintsGroupsList.length > 0, savedJobItemsAgainsComplaint.length > 0]);
    // memoize the debounce call with useMemo
    var debouncedSendRequest = React.useMemo(function () {
        return debounce(sendRequest, 500);
    }, [sendRequest]);
    var isDesktop = useMediaQuery('(min-width:600px)');
    var handleSearchChange = function (event) {
        // setSearchText(event.target.value);
        if (event.target.value.length > 2) {
            getSearchResult(event.target.value);
        }
    };
    var getSearchResult = function (searchTerm) { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy, _documentDetailsGetBy2, _ModuleDetailsGetById, _searchResponse$paylo, _searchResponse$paylo2, productID, searchJobRequestBody, searchResponse, _searchResponse$paylo3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    productID = (_documentDetailsGetBy = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.ProductId) !== null && _documentDetailsGetBy !== void 0 ? _documentDetailsGetBy : ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.ProductId;
                    searchJobRequestBody = {
                        ProductId: productID,
                        Keyword: searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLocaleLowerCase(),
                        ComplaintGroupIds: complaintsGroupsList.map(function (item) { return item.id; }),
                        ComplaintIds: savedJobItemsAgainsComplaint.map(function (item) { return item.ComplaintId; })
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ComplaintsJobItemsSearchURL,
                            request: searchJobRequestBody
                        }))];
                case 2:
                    searchResponse = _a.sent();
                    if ((_searchResponse$paylo = searchResponse.payload) !== null && _searchResponse$paylo !== void 0 && (_searchResponse$paylo = _searchResponse$paylo.value) !== null && _searchResponse$paylo !== void 0 && _searchResponse$paylo.success && (_searchResponse$paylo2 = searchResponse.payload) !== null && _searchResponse$paylo2 !== void 0 && (_searchResponse$paylo2 = _searchResponse$paylo2.value) !== null && _searchResponse$paylo2 !== void 0 && _searchResponse$paylo2.data) {
                        setSearchResult((_searchResponse$paylo3 = searchResponse.payload) === null || _searchResponse$paylo3 === void 0 || (_searchResponse$paylo3 = _searchResponse$paylo3.value) === null || _searchResponse$paylo3 === void 0 ? void 0 : _searchResponse$paylo3.data);
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getTranslateToJobItems = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy3, _documentDetailsGetBy4, _ModuleDetailsGetById2, _result$payload, _result$payload2, complaintRequest, result, _result$payload3, _preDocumentFetch$dat, groups, _SavedJobItemsRespons, _SavedJobItemsRespons2, jobItemURL, requestBody, SavedJobItemsResponse, _SavedJobItemsRespons3, SavedJobItems, countMap_1, updatedSavedJobItems_1, resultArray_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowSkeleton(true);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    complaintRequest = {
                        ProductId: (_documentDetailsGetBy3 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.ProductId) !== null && _documentDetailsGetBy3 !== void 0 ? _documentDetailsGetBy3 : ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.ProductId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'ComplaintGroupList',
                            url: ComplaintGroupURL,
                            request: complaintRequest
                        }))];
                case 2:
                    result = _a.sent();
                    if (!(result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data)) return [3 /*break*/, 7];
                    groups = result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data;
                    setComplaintsGroupsList(groups);
                    if (!(requestID || (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat = preDocumentFetch.data) === null || _preDocumentFetch$dat === void 0 ? void 0 : _preDocumentFetch$dat.length) > 0)) return [3 /*break*/, 4];
                    jobItemURL = void 0;
                    requestBody = {};
                    if (isFromJobCard) {
                        requestBody.JobCardId = requestID || (preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentId);
                        jobItemURL = getSavedJobItemsJobCardUrl;
                    }
                    else {
                        requestBody.PreJobCardDocumentId = requestID || (preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentId);
                        jobItemURL = getSavedJobItemsUrl;
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'customerDetailsTrnalsteToJob',
                            url: jobItemURL,
                            request: requestBody
                        }))];
                case 3:
                    SavedJobItemsResponse = _a.sent();
                    if ((_SavedJobItemsRespons = SavedJobItemsResponse.payload.value) !== null && _SavedJobItemsRespons !== void 0 && _SavedJobItemsRespons.success && (_SavedJobItemsRespons2 = SavedJobItemsResponse.payload.value) !== null && _SavedJobItemsRespons2 !== void 0 && _SavedJobItemsRespons2.data) {
                        SavedJobItems = (_SavedJobItemsRespons3 = SavedJobItemsResponse.payload.value) === null || _SavedJobItemsRespons3 === void 0 ? void 0 : _SavedJobItemsRespons3.data;
                        countMap_1 = {};
                        updatedSavedJobItems_1 = [];
                        SavedJobItems.forEach(function (item) {
                            var complaintGroupId = item.ComplaintGroupId;
                            countMap_1[complaintGroupId] = (countMap_1[complaintGroupId] || 0) + 1;
                            updatedSavedJobItems_1.push(_objectSpread(_objectSpread({}, item), {}, {
                                isCheckBoxClicked: true
                            }));
                        });
                        resultArray_1 = [];
                        groups.map(function (item) {
                            var count = countMap_1[item.id];
                            if (count && count > 0) {
                                resultArray_1.push(_objectSpread(_objectSpread({}, item), {}, {
                                    selectedValueCount: count || 0,
                                    isSkeletonVisible: true
                                }));
                            }
                        });
                        setListValue(resultArray_1);
                        setSavedJobItemsAgainsCompalint(updatedSavedJobItems_1);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setListValue(groups);
                    _a.label = 5;
                case 5: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 6:
                    _a.sent();
                    setShowSkeleton(false);
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 8:
                    _a.sent();
                    setShowSkeleton(false);
                    _a.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleAccordianDetails = function (id, index, expanded) { return __awaiter(_this, void 0, void 0, function () {
        var _selectedAccordianGro, updatedListValue, selectedAccordianGroupItem, res, _selectedAccordianGro2, ReplaceJobItemsForGroup_1, loopPromiose, jobItemsByComplaintGroupByAlphabeticalOrder, filterArrayChecked;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedListValue = __spreadArray([], listValue, true);
                    selectedAccordianGroupItem = _objectSpread({}, updatedListValue[index]);
                    if (selectedAccordianGroupItem.data || loader.isLoaderOpen) {
                        return [2 /*return*/];
                    }
                    // let groups = ComplaintGroupList
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    // let groups = ComplaintGroupList
                    _a.sent();
                    return [4 /*yield*/, getJobListByComplaintGrpId(id)];
                case 2:
                    res = _a.sent();
                    selectedAccordianGroupItem.data = res;
                    if (!((selectedAccordianGroupItem === null || selectedAccordianGroupItem === void 0 || (_selectedAccordianGro = selectedAccordianGroupItem.data) === null || _selectedAccordianGro === void 0 ? void 0 : _selectedAccordianGro.length) > 0)) return [3 /*break*/, 4];
                    ReplaceJobItemsForGroup_1 = [];
                    loopPromiose = (_selectedAccordianGro2 = selectedAccordianGroupItem.data) === null || _selectedAccordianGro2 === void 0 ? void 0 : _selectedAccordianGro2.map(function (accordianItem) { return __awaiter(_this, void 0, void 0, function () {
                        var matchingItem, _matchingItem, _matchingItem2, _audioAttachementURLs, _audioAttachementURLs2, _audioAttachementURLs3, _audioAttachementURLs4, _audioAttachementURLs5, _audioAttachementURLs6, imageAttachementURLs_1, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, audioAttachmentsUrlWithMediaType2, downloadImagePromise, downloadAudioPromise, sortedImages;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    matchingItem = savedJobItemsAgainsComplaint === null || savedJobItemsAgainsComplaint === void 0 ? void 0 : savedJobItemsAgainsComplaint.find(function (jobItem) { return accordianItem.ComplaintId === jobItem.ComplaintId; });
                                    if (!matchingItem) return [3 /*break*/, 4];
                                    matchingItem = _objectSpread({}, matchingItem);
                                    if (!(matchingItem && (_matchingItem = matchingItem) !== null && _matchingItem !== void 0 && _matchingItem.ImageAttachments && ((_matchingItem2 = matchingItem) === null || _matchingItem2 === void 0 || (_matchingItem2 = _matchingItem2.ImageAttachments) === null || _matchingItem2 === void 0 ? void 0 : _matchingItem2.length) > 0)) return [3 /*break*/, 3];
                                    imageAttachementURLs_1 = [];
                                    audioAttachementURLs = [];
                                    imageAttachmentsUrlWithMediaType1 = matchingItem.ImageAttachments.filter(function (item) { return item.MediaType === 1; });
                                    audioAttachmentsUrlWithMediaType2 = matchingItem.ImageAttachments.filter(function (item) { return item.MediaType === 2; });
                                    downloadImagePromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                                        var base64, error_1;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([1, 3, , 4]);
                                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, matchingItem.ComplaintId, translateToJobDownloadAttchementURl)];
                                                case 2:
                                                    base64 = _a.sent();
                                                    imageAttachementURLs_1.push({
                                                        blobUrl: base64,
                                                        attachmentId: imageItem.AttachmentId,
                                                        isAlreadyUploaded: true,
                                                        _ts: imageItem._ts
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    error_1 = _a.sent();
                                                    console.error("error", error_1);
                                                    return [3 /*break*/, 4];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    downloadAudioPromise = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                                        var base64, error_2;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([1, 3, , 4]);
                                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, matchingItem.ComplaintId, translateToJobDownloadAttchementURl)];
                                                case 2:
                                                    base64 = _a.sent();
                                                    audioAttachementURLs.push({
                                                        audioUrl: base64,
                                                        AttachmentId: imageItem.AttachmentId,
                                                        isAlreadyUploaded: true
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    error_2 = _a.sent();
                                                    console.error("error", error_2);
                                                    return [3 /*break*/, 4];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, Promise.all(downloadAudioPromise)];
                                case 2:
                                    _a.sent();
                                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs_1);
                                    matchingItem.images = sortedImages;
                                    matchingItem.audioUrl = (_audioAttachementURLs = (_audioAttachementURLs2 = audioAttachementURLs[0]) === null || _audioAttachementURLs2 === void 0 ? void 0 : _audioAttachementURLs2.audioUrl) !== null && _audioAttachementURLs !== void 0 ? _audioAttachementURLs : "";
                                    matchingItem.audioAttachmentId = (_audioAttachementURLs3 = (_audioAttachementURLs4 = audioAttachementURLs[0]) === null || _audioAttachementURLs4 === void 0 ? void 0 : _audioAttachementURLs4.AttachmentId) !== null && _audioAttachementURLs3 !== void 0 ? _audioAttachementURLs3 : "";
                                    matchingItem.isAudioAlreadyUploaded = (_audioAttachementURLs5 = (_audioAttachementURLs6 = audioAttachementURLs[0]) === null || _audioAttachementURLs6 === void 0 ? void 0 : _audioAttachementURLs6.isAlreadyUploaded) !== null && _audioAttachementURLs5 !== void 0 ? _audioAttachementURLs5 : false;
                                    matchingItem.isCheckBoxClicked = true;
                                    matchingItem.selectedValueCount = accordianItem.selectedValueCount;
                                    _a.label = 3;
                                case 3:
                                    ReplaceJobItemsForGroup_1.push(matchingItem);
                                    return [3 /*break*/, 5];
                                case 4:
                                    ReplaceJobItemsForGroup_1.push(accordianItem);
                                    _a.label = 5;
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(loopPromiose)];
                case 3:
                    _a.sent();
                    jobItemsByComplaintGroupByAlphabeticalOrder = ReplaceJobItemsForGroup_1.sort(function (a, b) {
                        if ((a === null || a === void 0 ? void 0 : a.ComplaintName) < (b === null || b === void 0 ? void 0 : b.ComplaintName)) {
                            return -1;
                        }
                        if ((a === null || a === void 0 ? void 0 : a.ComplaintName) > (b === null || b === void 0 ? void 0 : b.ComplaintName)) {
                            return 1;
                        }
                        return 0;
                    });
                    filterArrayChecked = jobItemsByComplaintGroupByAlphabeticalOrder === null || jobItemsByComplaintGroupByAlphabeticalOrder === void 0 ? void 0 : jobItemsByComplaintGroupByAlphabeticalOrder.filter(function (item) { return item.isCheckBoxClicked; });
                    selectedAccordianGroupItem.data = filterArrayChecked;
                    _a.label = 4;
                case 4:
                    selectedAccordianGroupItem.isSkeletonVisible = false;
                    updatedListValue[index] = selectedAccordianGroupItem;
                    setListValue(updatedListValue);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 5:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getJobListByComplaintGrpId = function (groupItem) { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy5, _ModuleDetailsGetById3, _result$payload4, _result$payload5, productID, requestBody, result, _result$payload6, jobItemsByComplaintGroup;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    productID = documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.ProductId : ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data ? ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.ProductId : '';
                    requestBody = {
                        ComplaintGroupId: groupItem,
                        ProductId: productID
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'ComplaintGroupBasedOnIdList',
                            url: ComplaintGroupBasedOnIdURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.value) !== null && _result$payload4 !== void 0 && _result$payload4.success && result !== null && result !== void 0 && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && (_result$payload5 = _result$payload5.value) !== null && _result$payload5 !== void 0 && _result$payload5.data) {
                        jobItemsByComplaintGroup = __spreadArray([], (result === null || result === void 0 || (_result$payload6 = result.payload) === null || _result$payload6 === void 0 || (_result$payload6 = _result$payload6.value) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.data), true);
                        return [2 /*return*/, jobItemsByComplaintGroup];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (panel) { return function (event, newExpanded) {
        setExpanded(newExpanded ? panel : null);
    }; };
    var onChange = function (event) {
        var searchTerm = event.target.value;
        setSearchValue(searchTerm);
        debouncedSendRequest(event);
    };
    // const firstArrayComplaintIds = new Set(
    //   listValue.flatMap((item: any) => item.data?.map((complaint: any) => complaint.ComplaintId))
    // );
    // const secondArrayComplaintIds = searchResult.flatMap((group: any) =>
    //   group.GetComplaints.map((complaint: any) => complaint.ComplaintId)
    // );
    // const unmatchedComplaintIds = secondArrayComplaintIds.filter(id => firstArrayComplaintIds.has(id));
    // console.log("unmatchedComplaintIds", unmatchedComplaintIds);
    return /*#__PURE__*/ React.createElement(Drawer, {
        id: "view-job-drawer",
        anchor: "right",
        open: props.isOpen,
        onClose: props.onClose,
        sx: {
            display: {
                xs: 'block'
            },
            '& .MuiDrawer-paper': {
                width: {
                    xs: '100%',
                    sm: '50%',
                    md: '40%',
                    lg: '35%',
                    xl: '35%'
                }
            }
        }
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(PageHeading, null, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        xs: 11,
        justifyContent: 'flex-start'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'lg',
            fontWeight: 'strong',
            color: 'text.primary'
        },
        id: "jobItems",
        align: "left"
    }, props.title)), /*#__PURE__*/ React.createElement(Grid, {
        xs: 1,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "closeIconBtn",
        onClick: props.onClose,
        sx: {
            marginLeft: {
                md: "8px",
                sm: '8px'
            }
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "crossIcon",
        src: CrossIcon,
        alt: "settingIcon"
    })))), /*#__PURE__*/ React.createElement(Loader, null)), isDesktop ? null : /*#__PURE__*/ React.createElement(DrawerHeader, null), loader.isLoaderOpen ? /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null), showSkeleton ? /*#__PURE__*/ React.createElement(JobItemsLoader, null) : /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        size: "small",
        fullWidth: true,
        type: "text",
        placeholder: t("Search job items"),
        InputProps: {
            startAdornment: /*#__PURE__*/ React.createElement("img", {
                height: 20,
                width: 20,
                src: SearchIcon,
                style: {
                    marginRight: "6px"
                }
            }),
            endAdornment: searchValue.length > 0 && /*#__PURE__*/ React.createElement("img", {
                src: CrossIcon,
                id: "clear-job-items-search",
                onClick: function () {
                    setSearchValue('');
                    setSearchResult([]);
                }
            })
        },
        style: {
            width: '90%'
        },
        onChange: onChange,
        id: "searchTranslateToJob"
        // disabled={isDisabled}
        ,
        value: searchValue
    })), listValue && listValue.length > 0 ? /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, listValue.map(function (item, index) {
        var _item$data;
        var existInSearch = searchResult.find(function (searchItem) { return searchItem.ComplaintGroupId === item.id; });
        var jobComplaints = searchResult.flatMap(function (group) { return group.GetComplaints.map(function (complaint) { return complaint.ComplaintId; }); });
        var isMatchFound = (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.some(function (searchedItem) { return jobComplaints.includes(searchedItem.ComplaintId); });
        if (searchValue.length >= 3) {
            if (!existInSearch) {
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
            }
        }
        return /*#__PURE__*/ React.createElement(Accordion, {
            id: "view-job-accordian",
            key: index,
            expanded: expanded === (item === null || item === void 0 ? void 0 : item.id),
            onChange: handleChange(item === null || item === void 0 ? void 0 : item.id)
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            id: "view-job-summary",
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    fontSize: '1.5rem'
                }
            }),
            onClick: function () { return handleAccordianDetails(item.id, index, expanded === item.id); }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: 'lg',
                fontWeight: 'normal',
                color: 'text.primary'
            }
        }, item === null || item === void 0 ? void 0 : item.Name), (item === null || item === void 0 ? void 0 : item.selectedValueCount) > 0 && /*#__PURE__*/ React.createElement(Chip, {
            id: "jobItemCounts",
            label: item === null || item === void 0 ? void 0 : item.selectedValueCount,
            color: "primary",
            variant: "filled",
            shape: "circular",
            sx: {
                ml: '10px'
            }
        })), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                padding: 2,
                paddingTop: 0,
                '& .MuiAccordionDetails-root': {
                    '& .css-cwppp': {
                        borderRadius: '8px'
                    }
                }
            }
        }, searchValue.length >= 3 && item.data && !isMatchFound ? /*#__PURE__*/ React.createElement(MuiStack, {
            paddingY: 1,
            justifyContent: 'center',
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: 'lg',
                fontWeight: 'normal',
                color: 'text.primary'
            }
        }, t("No result found"))) : /*#__PURE__*/ React.createElement(ViewJobsDetails, {
            searchValue: searchValue,
            searchedItems: existInSearch !== null && existInSearch !== void 0 && existInSearch.GetComplaints ? existInSearch === null || existInSearch === void 0 ? void 0 : existInSearch.GetComplaints : [],
            listItems: item === null || item === void 0 ? void 0 : item.data,
            isSkeletonVisible: item.isSkeletonVisible
        })));
    })) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1,
        width: '100%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'lg',
            fontWeight: 'normal',
            color: 'text.primary'
        }
    }, t("No data found"))))));
}
